import React from 'react';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import ShowContainer from '../../shared/components/show/ShowContainer';
import FormWrapper from '../../shared/components/form/FormWrapper';
import DatePickerField from '../../shared/components/form/DatePickerFfield';

const validationSchema = Yup.object().shape({
  id: Yup.number().required('Required'),
  arrivalDate: Yup.string().required('Required'),
});

const Form = () => (
  <Container>
    <ShowContainer>
      {
        ({ id }) => {
          if (!id) return null;
          const initialValues = { id, arrivalDate: '' };

          return (
            <FormWrapper
              initialValues={initialValues}
              validationSchema={validationSchema}
              formUrlSuffix={`/${id}/mark_as_arrived`}
              formTitle="Mark As Arrived Form"
              formSubTitle={`Please add the date and confirm the arrival of Receiving Shipment #${id}`}
              successModalTitle="Receiving Shipment Updated!"
              successModalMessage="You'll be sent back to the Receiving Shipments index"
              submitButtonText="Mark As Arrived"
              successUrl="/orders/receiving-shipments"
            >
              <div
                className="customizer__form-group-wrap no-bottom-line col-md-12"
                style={{ width: '100%' }}
              >
                <div className="mx-3">
                  <Row style={{ width: '100%' }}>
                    <Col lg={6}>
                      <div className="form__form-group">
                        <DatePickerField
                          fieldName="arrivalDate"
                          label="Arrival Date"
                          placeholder="Arrival Date..."
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </FormWrapper>
          );
        }
      }
    </ShowContainer>
  </Container>
);

export default withRouter(connect()(Form));
